import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { NavParams, NavController, ModalController, Modal, ViewController } from 'ionic-angular';

/**
 * Using PDF.js library
 * See https://mozilla.github.io/pdf.js/
 * Needs to be already declared globally (index.html)
 */


@Component({
  selector: 'pdf-viewer',
  templateUrl: 'pdf-viewer.html'
})
export class PdfViewerComponent implements OnInit {

  @ViewChild('canvasElementRef') canvasRef: ElementRef;

  pdfState = {
    pdf: null,
    currentPage: 1,
    zoom: 1
  };

  constructor(private params: NavParams, private view: ViewController) {
  }

  ngOnInit() {
    // const blob = (this.params.get('pdfBlob') as Blob);
    // (blob as any).arrayBuffer().then(docArrayBuffer => {
    //   pdfjsLib.getDocument({
    //     data: docArrayBuffer,
    //     disableFontFace: true
    //   }).promise.then(doc => {

    //     this.pdfState.pdf = doc;
    //     this.render();
    //   });
    // });

  }

  render() {
    // this.pdfState.pdf.getPage(this.pdfState.currentPage).then((page) => {
    //   const canvas = this.canvasRef.nativeElement;
    //   const ctx = canvas.getContext('2d');
    //   // const viewport = page.getViewport(this.pdfState.zoom);
    //   // canvas.width = viewport.width;
    //   // canvas.height = viewport.height;


    //   let unscaledViewport = page.getViewport(1);
    //   let scale = Math.min((canvas.height / unscaledViewport.height), (canvas.width / unscaledViewport.width));
    //   let viewport = page.getViewport(scale);

    //   page.render({
    //     canvasContext: ctx,
    //     viewport: viewport
    //   });

    // });
  }

  close() {
    this.view.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/pdf-viewer/pdf-viewer.ts